import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { FileText, Plus, Eye, Edit, Send } from 'lucide-react';
import { useUkstrStore } from '../data/ukstrStore';
import { Role } from '../data/rbac';
export default function UkstrList() {
  const navigate = useNavigate();
  const tasks = useUkstrStore(s => s.tasks);
  const role = localStorage.getItem('bimcs_role') as Role || 'Super Admin Nasional';
  const canCreate = ['Super Admin Nasional', 'Analis Nasional', 'Analis', 'Kepala BINDA'].includes(role);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-3982">
      <div className="flex items-center justify-between" data-id="element-3983">
        <div data-id="element-3984">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground uppercase" data-id="element-3985">
            Penjabaran UK/STR
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-3986">
            Daftar Tugas Intelijen Strategis
          </p>
        </div>
        {canCreate && <Button onClick={() => navigate('/ukstr/new')} className="bg-primary text-primary-foreground font-mono text-xs" data-id="element-3987">
            <Plus className="w-4 h-4 mr-2" data-id="element-3988" /> Buat UK/STR Baru
          </Button>}
      </div>

      <Card className="glass-panel border-border/50" data-id="element-3989">
        <CardContent className="p-0" data-id="element-3990">
          <div className="overflow-x-auto" data-id="element-3991">
            <table className="w-full text-sm text-left" data-id="element-3992">
              <thead className="text-xs text-muted-foreground uppercase bg-black/40 border-b border-border/50 font-mono" data-id="element-3993">
                <tr data-id="element-3994">
                  <th className="px-4 py-3" data-id="element-3995">Nomor / Judul</th>
                  <th className="px-4 py-3" data-id="element-3996">Klasifikasi</th>
                  <th className="px-4 py-3" data-id="element-3997">Batas Waktu</th>
                  <th className="px-4 py-3" data-id="element-3998">Wilayah</th>
                  <th className="px-4 py-3" data-id="element-3999">Status</th>
                  <th className="px-4 py-3 text-right" data-id="element-4000">Aksi</th>
                </tr>
              </thead>
              <tbody data-id="element-4001">
                {tasks.map(task => <tr key={task.id} className="border-b border-border/50 hover:bg-white/5 transition-colors" data-id="element-4002">
                    <td className="px-4 py-3" data-id="element-4003">
                      <div className="font-bold text-primary" data-id="element-4004">{task.nomor}</div>
                      <div className="text-xs text-muted-foreground mt-0.5" data-id="element-4005">
                        {task.judul || task.isuStrategis}
                      </div>
                    </td>
                    <td className="px-4 py-3 font-mono text-xs" data-id="element-4006">
                      <span className={task.klasifikasi === 'SANGAT RAHASIA' ? 'text-destructive' : 'text-orange-500'} data-id="element-4007">
                        {task.klasifikasi}
                      </span>
                    </td>
                    <td className="px-4 py-3 font-mono text-xs" data-id="element-4008">
                      {task.batasWaktu}
                    </td>
                    <td className="px-4 py-3" data-id="element-4009">{task.wilayah}</td>
                    <td className="px-4 py-3" data-id="element-4010">
                      <Badge variant="outline" className="font-mono text-[10px] uppercase" data-id="element-4011">
                        {task.status}
                      </Badge>
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-4012">
                      <Button variant="ghost" size="sm" onClick={() => navigate(`/ukstr/${task.id}`)} data-id="element-4013">
                        <Eye className="w-4 h-4" data-id="element-4014" />
                      </Button>
                    </td>
                  </tr>)}
                {tasks.length === 0 && <tr data-id="element-4015">
                    <td colSpan={6} className="px-4 py-8 text-center text-muted-foreground font-mono text-xs" data-id="element-4016">
                      Belum ada data UK/STR.
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>;
}